import axios from 'axios';
import _ from 'lodash';

const instance = axios.create({
  baseURL: process.env.BASE_URL
});

export const handleGetCapsule = async (payload) => {

  const { capsuleId, ...params } = { ...payload };

  let queryString = '/'

  if (params && !_.isEmpty(params)) {
    queryString = '/?' + Object.keys(params).map(key => _.snakeCase(key) + '=' + params[key]).join('&');
  }

  try {
    const response = await instance.get(`/capsules/${capsuleId}${queryString}`);

    return response;
  } catch (error) {
    return error;
  }
};

export const handleDestroyCapsuleRequest = async (capsuleId) => {
  try {
    const response = await instance.delete(`/capsules/${capsuleId}`);

    return response;
  } catch (error) {
    return error;
  }
};

export const capsulePublishableRequest = async (capsuleId) => {
  try {
    const response = await instance.get(`/capsules/${capsuleId}/publishable`);
    return response;
  } catch (error) {
    return error;
  }
};

// Interface: (:layerId, :products)
export const handleUpdateLayerProductSequencesRequest = async (payload) => {
  const layerId = payload['layerId']
  const sequencedLayerProductIds = payload['layerProducts'].map(lp => lp.id);
  const params = { sequenced_layer_product_ids: sequencedLayerProductIds }

  try {
    const response = await instance.patch(`/layers/${layerId}`, { layer: params });

    return response;
  } catch (error) {
    return error;
  }
};

export const handlePublishCapsuleRequest = async (payload) => {
  const capsuleId = payload['capsuleId']

  try {
    const response = await instance.post(`/capsules/${capsuleId}/publish`);

    return response;
  } catch (error) {
    return error;
  }
};

export const handleUpdateCapsuleDetails = async (payload) => {
  const capsuleId = payload['capsuleId']

  try {
    const response = await instance.put(`/capsules/${capsuleId}`, payload);

    return response;
  } catch (error) {
    return error;
  }
};

export const handleDuplicateCapsule = async (payload) => {
  const capsuleId = payload['capsuleId']

  try {
    const response = await instance.post(`/capsules/${capsuleId}/duplicate`);

    return response;
  } catch (error) {
    return error;
  }
};



// WEBPACK FOOTER //
// ./src/store/api/capsule/index.js